import React, { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import clsx from "clsx";
import { answerStyles } from "./answer.styles";

interface Answer {
  disabledSelection?: boolean;
  order: number;
  focusId: number;
  name: string;
}

interface AnswerProps {
  answer: Answer;
  isAnswerSelected: boolean;
  answerClass: string;
  onClick: (answer: Answer) => void;
  renderImage: (order: number) => void;
}

export const Answer = React.memo((props: AnswerProps) => {
  const {
    answer,
    onClick: handleClick,
    isAnswerSelected,
    renderImage,
    answerClass,
  } = props;
  const [selected, setSelected] = useState(isAnswerSelected);
  const classes = answerStyles();

  useEffect(() => {
    if (selected !== isAnswerSelected) {
      setSelected(isAnswerSelected);
    }
  }, [isAnswerSelected, selected]);

  const onClick = () => {
    let isSelected = !selected;

    if (answer.disabledSelection) {
      isSelected = false;
    }

    setSelected(isSelected);
    handleClick?.(answer);
  };

  return (
    <Grid container item md={2} sm={4} xs={6}>
      <Button
        className={clsx({
          [classes.answer]: true,
          [classes.selected]: selected,
          [classes.unselected]: !selected,
          [answerClass]: answerClass,
        })}
        fullWidth
        onClick={onClick}
        disabled={!isAnswerSelected && answer.disabledSelection}
      >
        {renderImage ? (
          <>
            <Typography component="div" className="answerDescription">
              {answer.name}
            </Typography>
            {renderImage?.(answer.focusId)}
          </>
        ) : (
          <Typography component="div" className="answerDescription">
            {answer.name}
          </Typography>
        )}
      </Button>
    </Grid>
  );
});
